import React, { useState, useRef, useCallback, useEffect } from 'react';
import LLMExistingCombos from 'Components/Forms/LLMCombosBars/LLMExistingCombos';

const ComboItemTemplate = React.memo((props) => {
  const {
    item,
    dragHandleProps,
    allModels,
    openModelsDialog,
    startEditing,
    onClone,
  } = props;
  const [dragging, setDragging] = useState(false);
  const containerRef = useRef(null);
  const pressTimerRef = useRef(null);
  const initialXRef = useRef(0);
  const initialYRef = useRef(0);

  const handleTouchStart = useCallback(
    (e) => {
      const touch = e.touches[0];
      initialXRef.current = touch.clientX;
      initialYRef.current = touch.clientY;
      pressTimerRef.current = setTimeout(() => {
        setDragging(true);
        if (props.onDragStart) {
          props.onDragStart(item);
        }
      }, 1000);
    },
    [item, props]
  );

  const handleTouchMove = useCallback(
    (e) => {
      const touch = e.touches[0];
      const moveThreshold = 10;
      if (!dragging) {
        if (
          Math.abs(touch.clientX - initialXRef.current) > moveThreshold ||
          Math.abs(touch.clientY - initialYRef.current) > moveThreshold
        ) {
          clearTimeout(pressTimerRef.current);
          pressTimerRef.current = null;
        }
        return;
      }
      if (props.onDrag) {
        const deltaY = touch.clientY - initialYRef.current;
        props.onDrag(item, deltaY);
      }
    },
    [dragging, item, props]
  );

  const handleTouchEnd = useCallback(() => {
    clearTimeout(pressTimerRef.current);
    pressTimerRef.current = null;
    if (dragging && props.onDragEnd) {
      props.onDragEnd(item);
    }
    if (containerRef.current) {
      containerRef.current.style.transform = '';
    }
    setDragging(false);
  }, [dragging, item, props]);

  useEffect(() => {
    const container = containerRef.current;
    const handleEl = container?.querySelector('[data-drag-handle]');
    if (handleEl) {
      handleEl.addEventListener('touchstart', handleTouchStart, false);
      handleEl.addEventListener('touchmove', handleTouchMove, false);
      handleEl.addEventListener('touchend', handleTouchEnd, false);
    }
    return () => {
      if (handleEl) {
        handleEl.removeEventListener('touchstart', handleTouchStart, false);
        handleEl.removeEventListener('touchmove', handleTouchMove, false);
        handleEl.removeEventListener('touchend', handleTouchEnd, false);
      }
    };
  }, [handleTouchStart, handleTouchMove, handleTouchEnd]);

  return (
    <div
      ref={containerRef}
      style={{ position: 'relative', display: 'flex', alignItems: 'center' }}
    >
      <LLMExistingCombos
        id={item.id}
        title={item.name}
        modelList={item.llms}
        onSelect={item.onSelect}
        store={item.store}
        theme={item.theme}
        position={item.position}
        dragHandleProps={dragHandleProps}
        allModels={allModels}
        openModelsDialog={openModelsDialog}
        startEditing={startEditing}
        onClone={onClone}
      />
    </div>
  );
});

export default ComboItemTemplate;
